/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getLesson = /* GraphQL */ `
  query GetLesson($id: ID!) {
    getLesson(id: $id) {
      id
      title
      description
      content
      order
      duration
      survey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listLessons = /* GraphQL */ `
  query ListLessons(
    $filter: ModelLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLessons(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        content
        order
        duration
        survey
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserLesson = /* GraphQL */ `
  query GetUserLesson($id: ID!) {
    getUserLesson(id: $id) {
      id
      userID
      lessonID
      progress
      startedAt
      finishedAt
      firstName
      lastName
      email
      dateOfBirth
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserLessons = /* GraphQL */ `
  query ListUserLessons(
    $filter: ModelUserLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserLessons(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        lessonID
        progress
        startedAt
        finishedAt
        firstName
        lastName
        email
        dateOfBirth
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const lessonsByOrder = /* GraphQL */ `
  query LessonsByOrder(
    $content: String!
    $order: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    lessonsByOrder(
      content: $content
      order: $order
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        content
        order
        duration
        survey
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
